/* eslint-disable react/no-array-index-key */
import React from 'react';

import { string } from 'prop-types';

export default function Loader({ fill = '#173475' /* $blue-darker */ }) {
  const style = { background: fill };

  return (
    <div
      className="sdp-loader sdp-mt-4 sdp-mb-4"
      data-testid="loader-component"
    >
      {[...new Array(4)].map((_, i) => (
        <span
          key={i}
          style={style}
          data-testid={`loader-component_loaderBar${i}`}
        />
      ))}
    </div>
  );
}

Loader.propTypes = {
  fill: string
};

Loader.defaultProps = {
  fill: ''
};
